import { defineStore } from "pinia";
import type { Sector } from "~/modules/sector/models/Sector.interface";
import { getFlattenSectors } from "~/modules/sector/utils/getFlattenSectors";
import { getGrantedSectors } from "~/modules/sector/utils/getGrantedSectors";

export const useSectorStore = defineStore("sectorStore", () => {
  const sectors = ref<Sector | undefined>();
  const selectedSectors = ref<Sector[]>([]);
  const availableSectors = ref<Sector[]>([]);
  const selectedSectorCodes = ref<number[]>([]);

  /**
   * Return the name of a sector by its ID
   * @param sectorId
   * @returns
   */
  function getSectorName(sectorId?: number): string | undefined {
    return sectors.value
      ? getFlattenSectors(sectors.value).find((currentSector) => {
          return currentSector.code === sectorId;
        })?.name
      : undefined;
  }

  /**
   * Set the sector store attributes
   * @param sector Sector
   */
  function setSectors(sector?: Sector) {
    sectors.value = sector;

    availableSectors.value = sectors.value
      ? getGrantedSectors([sectors.value])
      : [];

    // Keep the selected sectors which are present from the available sectors
    selectedSectors.value = selectedSectors.value.filter((selectedSector) =>
      availableSectors.value.find(
        (availableSector) => availableSector.code === selectedSector.code,
      ),
    );
  }

  /**
   * Change the selected sectors
   * @param newSelection
   */
  function changeSelection(newSelection: Sector[]) {
    selectedSectors.value = newSelection;
    selectedSectorCodes.value = selectedSectors.value.map(
      (sector) => sector.code,
    );
  }

  return {
    sectors,
    selectedSectors,
    selectedSectorCodes,
    availableSectors,
    setSectors,
    changeSelection,
    getSectorName,
  };
});
